<template>
  <cookie-law>
    <div class="container" slot-scope="props">
      <div class="message" slot="message">
        {{ translation.footer.cookie }}
        <a :href="page">{{ translation.blog.read_more }}</a>
      </div>
      <div class="buttons">
        <button class="skew" @click="props.accept" id="accept">
          <span>{{ translation.footer.accept_cookies }}</span>
        </button>
        <button class="skew" @click="props.close" id="ignore">
          <span>{{ translation.footer.ignore_cookies }}</span>
        </button>
      </div>
    </div>
  </cookie-law>
</template>
<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw },
  props: ["page"],
  data() {
    return {
      translation: this.$translations,
    };
  },
};
</script>

<style lang="scss" scoped>
.Cookie--base {
  background-color: $grey;
  z-index: 999999999;

  .container {
    display: flex;
    margin: auto;
    color: $dark-grey;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 $big-margin;

    @include res(tab-p) {
      padding: 0 12px;
      flex-direction: column;
    }

    .buttons {
      @include res(tab-p) {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
      }

      .skew {
        padding: 11px 20px;
        border: none;
        @include res(tab-p) {
          width: 50%;
        }
      }

      #accept {
        background-color: $brown;
        color: $white;
        margin-left: 50px;

        @include res(tab-p) {
          margin: 0;
        }
      }

      #close {
        background-color: $grey;

        @include res(tab-p) {
          margin-left: 50px;
        }
      }
    }

    .message {
      font-family: $font-text;

      @include res(tab-p) {
        margin-bottom: 14px;
      }

      a {
        color: $dark-grey;
        text-decoration: underline;
      }
    }
  }
}
</style>
